import { Component, Input } from '@angular/core';

@Component({
  selector: 'receipt',
  templateUrl: './receipt-template.component.html'
})
export class ReceiptTemplateComponent  {
  @Input("pdfModel") pdfModel: any;

  ClientName: string;
  ClientCompany: string;
  ClientAddress: string;
  ClientCity: string;
  ClientStreet: string;
  ClientState: string;
  ClientZip: string;
  ClientPhone: string;

  tempDate: Date;
  OrderDate: string;
  InvoiceNumber: number;
  CaseID: number;
  PaymentMethod: string;

  ProductType: string;
  ProductName: string;
  ProductAmount: number;

  EducationAmount: number;
  EmploymentAmount: number;
  LicenseAmount: number;
  AdditionalFeeAmount: number;
  SalesTaxAmount: number;
  SaleTotal: number;

  HasProduct: boolean;

  AddOnProducts: any;

  ngOnInit(): void {
    var test = this.pdfModel;
    this.ClientName = this.pdfModel.ClientName;
    this.ClientCompany = this.pdfModel.ClientCompany;
    this.ClientAddress = this.pdfModel.ClientAddress;
    this.ClientCity = this.pdfModel.ClientCity;
    this.ClientState = this.pdfModel.ClientState;
    this.ClientZip = this.pdfModel.ClientZip;
    this.ClientCompany = this.pdfModel.ClientCompany;
    this.ClientPhone = this.pdfModel.ClientPhone;

    this.OrderDate = this.pdfModel.OrderDate;
    this.InvoiceNumber = this.pdfModel.InvoiceNumber;
    this.CaseID = this.pdfModel.CaseNumber;
    this.PaymentMethod = this.pdfModel.PaymentMethod;

    this.SalesTaxAmount = this.pdfModel.Tax;
    this.SaleTotal = this.pdfModel.Total;
    this.AdditionalFeeAmount = this.pdfModel.FeeTotal;
    
    this.ProductAmount = this.pdfModel.BaseTotal;
    if(this.ProductAmount != 0){
      this.HasProduct = true;
    }
    this.ProductType = this.pdfModel.Package;
    this.ProductName = this.pdfModel.Package;

    this.AddOnProducts = this.pdfModel.AddOnProducts;
  }

}


// 733f4baa